// utils/getLocation.js
export const getCurrentLocation = () => {
  return new Promise(async (resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by your browser."));
      return;
    }

     try {
      const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

      if (permissionStatus.state === "denied") {
        // Browser permission was denied by user previously
        reject(
          new Error(
            "Location permission is blocked. Please go to your browser Settings → Site Settings → Location and allow this site."
          )
        );
        return;
      }
    } catch (e) {
      // navigator.permissions not supported on some browsers — continue anyway
    }

    navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            reject(
              new Error(
                "Location permission denied. Please allow location access in your browser settings."
              )
            );
            break;
          case error.POSITION_UNAVAILABLE:
            reject(
              new Error(
                "Location unavailable. Please enable GPS on your device:\n• Android: Settings → Location → Turn ON\n• iPhone: Settings → Privacy → Location Services → Turn ON"
              )
            );
            break;
          case error.TIMEOUT:
            reject(
              new Error("Location request timed out. Please ensure GPS is enabled and try again.")
            );
            break;
          default:
             reject(new Error("Unable to retrieve location. Please check GPS and try again."));
        }
      },
      {
        enableHighAccuracy: true, // uses GPS on mobile, not just WiFi/IP
        timeout: 10000,           // 10 seconds max wait
        maximumAge: 0,            // don't use cached location
      }
    );
  });
};
